var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 16,
    viewBox: "0 0 19 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.70378 12.177C3.99249 12.0032 2.86945 11.1567 2.22008 9.58485C2.74722 9.58485 3.22852 9.58485 3.70982 9.58485C3.7251 9.55462 3.73274 9.52439 3.74802 9.50172C2.00616 8.9047 1.02828 7.73333 0.913686 5.88182C1.45611 6.03296 1.96033 6.16899 2.46455 6.31258C2.47983 6.28235 2.50275 6.25212 2.51802 6.21433C1.76169 5.63999 1.24983 4.90694 1.04356 4.00007C0.837289 3.07809 0.967164 2.20146 1.45611 1.32482C3.49591 3.67511 6.03993 4.98251 9.08818 5.19411C9.14929 4.55175 9.11873 3.9245 9.27917 3.35015C10.0126 0.697572 13.2824 -0.247079 15.3604 1.56665C15.5743 1.74802 15.75 1.80848 16.0021 1.71779C16.5369 1.52131 17.0717 1.32482 17.6065 1.12078C17.721 1.07543 17.828 1.01497 17.9961 0.939402C17.7058 1.80092 17.1863 2.39794 16.5445 2.94206C16.8501 2.87405 17.1633 2.82115 17.4689 2.74557C17.7822 2.66245 18.0878 2.54909 18.4697 2.42817C18.019 3.10832 17.5148 3.63733 16.9189 4.0832C16.7126 4.23434 16.6438 4.39305 16.6438 4.64999C16.682 9.3808 13.4581 14.3383 7.77415 15.2301C5.33708 15.6155 3.01461 15.2452 0.829649 14.0814C0.676855 13.9983 0.5317 13.9076 0.378906 13.7791C2.31939 13.8396 4.0918 13.3861 5.70378 12.177Z",
    fill: "#BBBBBB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.b3f21ef85c65a7384984c241cf6b95f2.svg";
export { ForwardRef as ReactComponent };